// 商品属性
const attr_list = {
    heard_title: "Product Attributes",
    heard_btn: "Add",
    table_title: "Data List",
    table_label1: "Attribute Name",
    table_label2: "Item Type",
    table_label3: "List of optional values",
    table_label4: "Sort",
    table_btn1: "Edit",
    table_btn2: "Delete",
    dialog_title1: "Add Product Attributes",
    dialog_title2: "Edit product attributes",
    dialog_label1: "Item Type:",
    dialog_label2: "Attribute name:",
    dialog_label3: "Sort:",
    dialog_label4: "Optional values:",
    dialog_label5: "Add manually:",
    dialog_ph1: "Please select",
    dialog_tag: "Please enter",
    dialog_radio1: "Yes",
    dialog_radio2: "No",
    rule_msg1: "Please select a product type",
    rule_msg2: "Please enter the attribute name"
};

export default attr_list;
